'use client';

import { cn } from '@/lib/utils/utils';
import { formatMNT } from '@/lib/utils/formatters';
import type { IPrice } from '@/shared';

type PlusPackageOptionProps = {
  price: IPrice;
  selected: boolean;
  saleLabel: string;
  onSelect: () => void;
};

export function PlusPackageOption({
  price,
  selected,
  saleLabel,
  onSelect,
}: PlusPackageOptionProps) {
  const label = price.title ?? '';
  const isSale = price.sale > 0;

  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        'relative rounded-xl border p-4 text-center',
        selected ? 'border-primary bg-primary-50' : 'border-gray-200 bg-white'
      )}
    >
      {isSale ? (
        <span className="absolute top-0 -translate-y-1/2 left-1/2 -translate-x-1/2 rounded-lg bg-secondary px-2 py-1 text-xs font-normal text-white whitespace-nowrap">
          {saleLabel}
        </span>
      ) : null}

      <p className="text-sm text-gray-600">{label}</p>
      <div className="flex items-end justify-center gap-2">
        <span className="mt-1 text-lg font-semibold text-primary">
          {formatMNT(price.price)}
        </span>

        {isSale ? (
          <span className="text-xs text-gray-400 line-through mb-1">
            {formatMNT(price.price_old)}
          </span>
        ) : null}
      </div>
    </button>
  );
}
